/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_Point_2Inputs */

const en_outside_point_2 = /** @type {(inputs: Outside_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central keeps the books; sales invoices carry Nexxt's number`)
};

/**
* | output |
* | --- |
* | "Business Central keeps the books; sales invoices carry Nexxt's number" |
*
* @param {Outside_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_point_2 = /** @type {((inputs?: Outside_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_point_2(inputs)
});